import productViewDataLayer from "../autoload/gtm";

let locationId = $(".tours-of-the-day__filter").attr("data-location");
$(".tours-of-the-day__day").each(function () {
  $(this).click(function () {
    if (
      $(this)
        .siblings()
        .hasClass("active")
    ) {
      $(this)
        .siblings()
        .removeClass("active");
    }
    $(this).addClass("active");

    let date = $(this).attr("data-date");
    let data = {
      calendarDate: date,
      locationId: locationId,
    };
    $.ajax({
      url: themeVars.ajax_url,
      type: "POST",
      data: {
        action: "tourDate",
        data: data,
      },
      success: function (response) {
        $(".tours-of-the-day__list").html(response);

        //send GTM info
        productViewDataLayer($('.tours-of-the-day__list'), themeVars['title']);
      },
    });
  });
});

let tourOfDayCalendar = $(".tours-of-the-day__calendar");
tourOfDayCalendar.datepicker({
  altField: ".tours-of-the-day__calendar",
  dateFormat: "yy-mm-dd",
  firstDay: 1,
  dayNamesMin: ["S", "M", "T", "W", "T", "F", "S"],
  showOtherMonths: true,
  selectOtherMonths: true,
  prevText: "",
  nextText: "",
  onSelect: function () {
    $(".tours-of-the-day__calendar > .ui-datepicker-inline").hide();
    let calendarDate = $(this).val();
    let data = {
      calendarDate: calendarDate,
      locationId: locationId,
    };
    $.ajax({
      url: themeVars.ajax_url,
      type: "POST",
      data: {
        action: "tourDate",
        data: data,
      },
      success: function (response) {
        $(".tours-of-the-day__list").html(response);
        productViewDataLayer($('.tours-of-the-day__list'), themeVars['title']);
      },
    });
  },
});

$("html").click(function (e) {
  if ($(e.target).hasClass("tours-of-the-day__calendar")) {
    $(".tours-of-the-day__calendar > .ui-datepicker-inline").toggle();
    if (
      $(e.target)
        .siblings()
        .hasClass("active")
    ) {
      $(e.target)
        .siblings()
        .removeClass("active");
    }
    $(e.target).addClass("active");
  } else {
    if (!$(e.target).hasClass("ui-corner-all")) {
      $(".tours-of-the-day__calendar > .ui-datepicker-inline").hide();
    }
  }
});
$(".tours-of-the-day__calendar > .ui-datepicker-inline").hide();



// WEBPACK FOOTER //
// ./scripts/modules/tours-of-the-day.js